import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EvaluationFormEmptyStateMessage = () => (
  <Box textAlign="center" padding="s48">
    <Text.Normal>{i18n.t('ats.application_details.evaluations.empty_state_message')}</Text.Normal>
  </Box>
)
